export default __webpack_public_path__ + "static/media/user-enter2.69b53c30.mp3";